import http from '../../../service/axios';

export const branchAPI = {
  getBranches: async (lat: number, lng: number) =>
    await http.get('/branch/list', {
      params: {
        company_id: 1,
        lat_long: `${lat},${lng}`,
      },
      headers: {
        Language: localStorage.getItem('language') || 'uz',
      },
    }),

  getPickupBranches: async (lat: number, lng: number) =>
    await http.get('/branch/pickup-list', {
      params: {
        company_id: 1,
        lat_long: `${lat},${lng}`,
      },
      headers: {
        Language: localStorage.getItem('language') || 'uz',
      },
    }),

  getRecentlyOrderedBranches: async () =>
    await http.get('/branch/recently-ordered', {
      headers: {
        Language: localStorage.getItem('language') || 'uz',
      },
    }),
};
